module.exports = __webpack_public_path__ + "img/values.23846fb2.jpg";